import { REGISTRATION_STATUS_PENDING } from "./crmPayload";

export const REGISTRATION_SUPPORT_PHONE = "844-888-3318";
export const REGISTRATION_SUPPORT_EMAIL = "help@buxus.io";
export const DEFAULT_ERROR_MODAL_TITLE = "Oops! Something went wrong.";

export type RegistrationOutcomeKind = "pending" | "active" | "unknown";

export function registrationOutcomeFromResolvedStatus(
  resolvedStatus: string | null | undefined,
): RegistrationOutcomeKind {
  if (!resolvedStatus?.trim()) return "unknown";
  if (resolvedStatus.trim() === REGISTRATION_STATUS_PENDING) return "pending";
  return "active";
}

/** Browser success body paragraphs (buxusweb success modal parity). */
export function registrationSuccessParagraphs(
  outcome: RegistrationOutcomeKind,
  host: "browser" | "webview",
): string[] {
  if (outcome === "pending") {
    return [
      "Thank you for your interest in Buxus®.",
      "One of the steps we take to maintain the integrity of the system is to confirm you are a responder. You will receive publicly available information until we are able to confirm your role as a responder. This typically takes one (1) to two (2) business days.",
      "An email confirming increased access to Buxus® will be sent once that confirmation occurs.",
      `If you have any questions or need assistance in the meantime, please contact ${REGISTRATION_SUPPORT_PHONE} or ${REGISTRATION_SUPPORT_EMAIL}.`,
      "To access Buxus® once approved, please download the Buxus® app from the App Store or Google Play.",
      "You can also access the Buxus® Web version by going to www.Buxus.io.",
    ];
  }

  if (host === "webview") {
    return ["Thank you for registering with Buxus. To continue, please log in."];
  }

  return [
    "Thank you for registering with Buxus. To continue, please download the Buxus app from the App Store or Google Play Store or visit www.buxus.io to view the web-based version.",
  ];
}

export const REGISTRATION_FAILURE_MESSAGE =
  "Sorry, there was an error registering your account. Please try again.";
